export const SONG_OPENSEA_LINK = 'https://opensea.io/collection/arpeggisongs'
export const SOUND_OPENSEA_LINK = 'https://opensea.io/collection/arpeggisounds'
